const Drinks = (function() {
  
  function _renderDrinks(drinks, lang) {
    console.log('_ drinks render')
    let stuff = drinks.map(drink => {
        return `
            <div class="drinkk">
            
                <span>${drink[lang + "_title"]}</span>
                <span>${drink['dl']}</span> 
                <span>${drink['bottle']}</span>
            </div>
        `
    }).join("");
    console.log(stuff)
    return stuff;
  }

  function _renderCats(categories, drinks, lang) {
    console.log('cats render')
    let stuff = categories.map(cat => {
      console.log(cat)
      let items = drinks.filter(drink => drink.category === cat.hu); 
      console.log(items)
      return `
          <div class="drink-cat">
              <h2>${cat[lang]} <span>${cat["text_2"]}</span><span>${cat["text_1"]}</span></h2>
              ${_renderDrinks(items, lang)}
          </div>
      `
    }).join("");
    return stuff;
  }

  return {
    render: (categories, drinks, lang) => {
      console.log('drinks render')
      return `
          <div class="itallap">
              <h1>${lang === "hu" ? "Itallap" : "Drinks"}</h1>
              <div class="content">
                  ${_renderCats(categories, drinks, lang)}
              </div>
          </div>
      `
    }
  }
})()

export default Drinks;


// WEBPACK FOOTER //
// ./src/Drinks.js